/**
 * 
 */
export interface IFormElementViewModel {
    elementId: string;

    dataGet?: () => any;
    dataSet?: (data: any) => void;

    validate?: (vm: IFormElementViewModel) => string[];
}


/**
 * 
 */
export interface IFormElementViewModelOptions {
    title: string;
    helpText?: string;

    isLocked?: boolean;
    isRequired?: boolean;
}

/**
 * 
 */
export class FormElementViewModel {

    /**
     * 
     * @param context 
     * @param field 
     * @param options 
     * @param elementInstance 
     * @returns 
     */
    public static create<typeOfViewModel extends IFormElementViewModel, typeOfOptions extends IFormElementViewModelOptions>(
        context: any, field: string, options: typeOfOptions, elementInstance: number = undefined
    ): typeOfViewModel {
        const ret: IFormElementViewModel = {
            ...options,

            elementId: `${field}-${elementInstance ?? 1}`,

            dataGet: () => context[field],
            dataSet: (data) => context[field] = data,
        };
        return <any>ret;
    }
}